<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Mis Ajustes</h4>
        <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button @click="lock = !lock" block v-b-toggle.change-pass variant="default" size="lg" pill>
                    <b-icon :icon="(lock ? '' : 'un')+'lock-fill'" aria-hidden="true"></b-icon>
                    &nbsp;&nbsp;<span style="vertical-align: bottom;">Cambiar Contraseña</span>&nbsp;&nbsp;
                    <b-icon :icon="'caret-'+(lock ? 'up' : 'down')+'-fill'" aria-hidden="true"></b-icon>
                </b-button>
            </b-card-header>
            <b-collapse id="change-pass" visible accordion="my-pass" role="tabpanel">
                <b-card-body>
                    <b-form id="formAccount" @submit.stop.prevent="submit">
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.pass !== '' ? ' active' : '')">
                                    <b-input-group>
                                        <b-form-input
                                            name="pass"
                                            :type="passwordHidden ? 'password' : 'text'"
                                            v-model="form.pass"
                                            v-validate="'required:true'"
                                            :state="validateState('pass')"
                                            :data-vv-as="(labels.pass).toLowerCase()"
                                            :disabled="loading"
                                            aria-describedby="pass-live-feedback"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="outline-default"
                                                      @click="passwordHidden = !passwordHidden"
                                                      class="m-0 btlr-0 bblr-0">
                                                <i class="material-icons">{{
                                                        passwordHidden ? 'visibility_off' : 'visibility'
                                                    }}</i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <label class="form-control-label">{{ labels.pass }}:</label>
                                    <b-form-invalid-feedback id="pass-live-feedback">{{
                                            veeErrors.first('pass')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.pass_confirmation !== '' ? ' active' : '')">
                                    <b-input-group>
                                        <b-form-input
                                            name="pass_confirmation"
                                            :type="passwordHidden ? 'password' : 'text'"
                                            v-model="form.pass_confirmation"
                                            v-validate="'required:true'"
                                            :state="validateState('pass_confirmation')"
                                            :data-vv-as="(labels.pass_confirmation).toLowerCase()"
                                            :disabled="loading"
                                            aria-describedby="pass_confirmation-live-feedback"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="outline-default"
                                                      @click="passwordHidden = !passwordHidden"
                                                      class="m-0 btlr-0 bblr-0">
                                                <i class="material-icons">{{
                                                        passwordHidden ? 'visibility_off' : 'visibility'
                                                    }}</i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <label class="form-control-label">{{ labels.pass_confirmation }}:</label>
                                    <b-form-invalid-feedback id="pass_confirmation-live-feedback">{{
                                            veeErrors.first('pass_confirmation')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                            <b-col cols="12" md="5" align-self="start">
                                <b-form-group :class="'float-label' + (form.old_pass !== '' ? ' active' : '')">
                                    <b-input-group>
                                        <b-form-input
                                            name="old_pass"
                                            :type="passwordHidden ? 'password' : 'text'"
                                            v-model="form.old_pass"
                                            v-validate="'required:true'"
                                            :state="validateState('old_pass')"
                                            :data-vv-as="(labels.old_pass).toLowerCase()"
                                            :disabled="loading"
                                            aria-describedby="old_pass-live-feedback"
                                        ></b-form-input>
                                        <b-input-group-append>
                                            <b-button variant="outline-default"
                                                      @click="passwordHidden = !passwordHidden"
                                                      class="m-0 btlr-0 bblr-0">
                                                <i class="material-icons">{{
                                                        passwordHidden ? 'visibility_off' : 'visibility'
                                                    }}</i>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                    <label class="form-control-label">{{ labels.old_pass }}:</label>
                                    <b-form-invalid-feedback id="old_pass-live-feedback">{{
                                            veeErrors.first('old_pass')
                                        }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center">
                            <b-col cols="12" md="10" class="my-4 text-center">
                                <b-button type="submit" variant="default" size="lg" pill class="shadow px-5"
                                          form="formAccount" :disabled="loading">
                                    <b-spinner small type="grow" v-if="loading"></b-spinner>
                                    <b-icon icon="shield-lock-fill" aria-hidden="true" v-else></b-icon>
                                    &nbsp;&nbsp;<span>{{ loading ? labels.load : labels.save }}</span>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-card-body>
            </b-collapse>
        </b-card>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Settings",
    props: [ 'user' ],
    data: () => ({
        passwordHidden: true,
        labels: {
            old_pass: 'Contraseña Actual',
            pass: 'Nueva Contraseña',
            pass_confirmation: 'Confirmar Contraseña',

            load: 'Actualizando...',
            save: 'Actualizar'
        },
        form: {
            old_pass: '',
            pass: '',
            pass_confirmation: '',
        },
        lock: false,
        loading: false
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'infopage');
    },
    methods: {
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        submit() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;

                axios.post('/api/customer/password/update', this.form).then((res) => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    if (res.data.status === 'success') {
                        this.$store.dispatch('setUser', res.data);
                        this.$emit('success');
                        this.form = {
                            old_pass: '',
                            pass: '',
                            pass_confirmation: '',
                        };
                        this.$validator.reset();
                    }
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        }
    }
}
</script>

<style scoped>
.material-icons {
    font-size: 21px;
}
</style>
